import React, { type ReactNode } from 'react';

import { MDXProvider } from '@mdx-js/react';

import Link from '@atlaskit/link';

import { Blockquote } from './blockquote';
import { Bold } from './bold';
import { Column, Row } from './grid';
import { Heading } from './heading';
import { Image } from './image';
import { ListItem, UnorderedList } from './list';
import { Paragraph } from './paragraph';
import { Video } from './video';

const components = {
	// Deliberately omitting `h1` for a11y reasons. The page title should be the only `h1` on the page.
	// TODO: Throw an invariant in dev environment if `h1` is used
	h2: ({ children }: { children: ReactNode }) => <Heading level="h2">{children}</Heading>,
	h3: ({ children }: { children: ReactNode }) => <Heading level="h3">{children}</Heading>,
	h4: ({ children }: { children: ReactNode }) => <Heading level="h4">{children}</Heading>,
	h5: ({ children }: { children: ReactNode }) => <Heading level="h5">{children}</Heading>,
	h6: ({ children }: { children: ReactNode }) => <Heading level="h6">{children}</Heading>,
	p: Paragraph,
	b: Bold,
	strong: Bold,
	img: Image,
	blockquote: Blockquote,
	video: Video,
	ul: UnorderedList,
	li: ListItem,
	Row: Row,
	Column: Column,
	a: Link,
};

export const MDXBlogRenderer = ({ children }: { children: ReactNode }) => {
	return (
		<div>
			<MDXProvider components={components}>{children}</MDXProvider>
		</div>
	);
};
